<template>
  <div class="notification">
    <!-- Shop by category section -->
    <div class="wrapper-content">
      <!-- breadcrumb -->
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Notifications</h2>
        </div>
      </div>

      <div class="notifications">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="notification-list">
                <ul>
                  <li class="current" v-for="(item,index) in allNotification " :key="index">
                    <p>{{item.message}}</p>
                    <span>{{newdate(item.date)}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnotifications } from "./../services/api";
import moment from "moment";
export default {
  name: "product",
  data() {
    return {
      allNotification: []
    };
  },
  created() {
    this.notifications();
  },
  methods: {
    newdate(value) {
      if (value) {
        return moment(value).format("DD MMMM, YYYY hh:mm A");
      }
    },

    notifications() {
      localStorage.setItem("phoneNumber", this.phoneNumber);
      var requestData = {
        vendor_id: localStorage.getItem("vendorId"),
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token")
      };

      getnotifications(requestData)
        .then(result => {
          // console.log("aaaaaaaaa", result);
          if (result.data.successCode === 1) {
            this.allNotification = result.data.notifications;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
